import { RecommendationsModalState } from '../typings/recommendations';

export const SET_RECOMMENDATIONS_MODAL_DATA = 'SET_RECOMMENDATIONS_MODAL_DATA';
export type SET_RECOMMENDATIONS_MODAL_DATA = typeof SET_RECOMMENDATIONS_MODAL_DATA;

export interface SetRecommendationsModalDataAction {
    type: SET_RECOMMENDATIONS_MODAL_DATA;
    modalData: RecommendationsModalState;
}

export function setRecommendationsModalDataAction(
    modalData: RecommendationsModalState
): SetRecommendationsModalDataAction {
    return {
        type: SET_RECOMMENDATIONS_MODAL_DATA,
        modalData
    };
}

export const CLOSE_RECOMMENDATIONS_MODAL = 'CLOSE_RECOMMENDATIONS_MODAL';
export type CLOSE_RECOMMENDATIONS_MODAL = typeof CLOSE_RECOMMENDATIONS_MODAL;

export interface CloseRecommendationsModalAction {
    type: CLOSE_RECOMMENDATIONS_MODAL;
}

export function closeRecommendationsModal(): CloseRecommendationsModalAction {
    return {
        type: CLOSE_RECOMMENDATIONS_MODAL
    };
}

export type RecommendationsModalAction =
    | CloseRecommendationsModalAction
    | SetRecommendationsModalDataAction;
